/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Skeleton from "@mui/material/Skeleton";
import { useGetAvatarStyles } from "./index.styles";

const Avatar = ({ size = 88, rounded, src, fit = "contain", flatStyle }) => {
  const styles = useGetAvatarStyles({ size, rounded, fit, flatStyle });
  const [status, setStatus] = useState(src ? "loading" : "empty");

  useEffect(() => {
    setStatus(src ? "loading" : "empty");
  }, [src]);

  const showFallback = status === "empty" || status === "error";

  return (
    <div style={styles.wrapper}>
      {status === "loading" && (
        <Skeleton
          variant="circular"
          width="100%"
          height="100%"
          sx={{ position: "absolute", inset: 0 }}
        />
      )}
      {src && (
        <img
          alt="Avatar"
          css={[
            styles.dp,
            { position: "absolute", inset: 0 },
            status !== "loaded" && { opacity: 0 },
          ]}
          src={src}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      )}
      {showFallback && (
        <div
          css={[
            styles.dp,
            {
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0,0,0,0.04)",
              color: "rgba(0,0,0,0.3)",
            },
          ]}
        >
          <PersonOutlineIcon sx={{ fontSize: Math.round(size * 0.55) }} />
        </div>
      )}
      {!flatStyle && <div css={styles.statusIndicator} />}
    </div>
  );
};

export default Avatar;
